export default class AmenitiesType {
    static levels = [
        {
            value: 'standard',
            label: 'Standard Amenity'
        },
        {
            value: 'open',
            label: 'Open Amenity'
        },
        /** Standard Amenities */
        {
            value: 'Activity/ArtStudio',
            label: 'Activity/Art Studio'
        },
        {
            value: 'AmenityCenter',
            label: 'Amenity Center'
        },
        {
            value: 'Amphitheater',
            label: 'Amphitheater'
        },
        {
            value: 'Ballroom',
            label: 'Ballroom'
        },
        {
            value: 'Baseball',
            label: 'Baseball'
        },
        {
            value: 'Basketball',
            label: 'Basketball'
        },
        {
            value: 'BBQAreas',
            label: 'BBQ Areas'
        },
        {
            value: 'Beach',
            label: 'Beach'
        },
        {
            value: 'Billiards',
            label: 'Billiards'
        },
        {
            value: 'BocceBallCourt',
            label: 'Bocce Ball Court'
        },
        {
            value: 'Cabana',
            label: 'Cabana'
        },
        {
            value: 'CardRooms',
            label: 'Card Rooms'
        },
        {
            value: 'Clubhouse',
            label: 'Clubhouse'
        },
        {
            value: 'CommunityCenter',
            label: 'Community Center'
        },
        {
            value: 'ConferenceRoom/Hall',
            label: 'Conference Room/Hall'
        },
        {
            value: 'ConservationArea',
            label: 'Conservation Area'
        },
        {
            value: 'Cornhole',
            label: 'Cornhole'
        },
        {
            value: 'CoworkingSpaces',
            label: 'Coworking Spaces'
        },
        {
            value: 'DiscGolf',
            label: 'Disc Golf'
        },
        {
            value: 'DogGroomingRoom',
            label: 'Dog Grooming Room'
        },
        {
            value: 'DogPark',
            label: 'Dog Park'
        },
        {
            value: 'EventCenter',
            label: 'Event Center'
        },
        {
            value: 'EventLawn',
            label: 'Event Lawn'
        },
        {
            value: 'FirePit',
            label: 'Fire Pit'
        },
        {
            value: 'Fishing',
            label: 'Fishing'
        },
        {
            value: 'FitnessCenter',
            label: 'Fitness Center'
        },
        {
            value: 'GameRoom',
            label: 'Game Room'
        },
        {
            value: 'Garden',
            label: 'Garden'
        },
        {
            value: 'GolfCartPath/Access',
            label: 'Golf Cart Path/Access'
        },
        {
            value: 'GolfCourse',
            label: 'Golf Course'
        },
        {
            value: 'GolfSimulator',
            label: 'Golf Simulator'
        }, 
        {
            value: 'Greenbelt',
            label: 'Greenbelt'
        },
        {
            value: 'GuardedGate',
            label: 'Guarded Gate'
        },
        {
            value: 'HammockPark',
            label: 'Hammock Park'
        },
        {
            value: 'HeatedOutdoorPool/Spa',
            label: 'Heated Outdoor Pool/Spa'
        },
        {
            value: 'HorseshoePit',
            label: 'HorseshoePit'
        },
        {
            value: 'HotTub',
            label: 'HotTub'
        },
        {
            value: 'IndoorPool',
            label: 'Indoor Pool'
        },
        {
            value: 'Lake',
            label: 'Lake'
        },
        {
            value: 'LapPool',
            label: 'Lap Pool'
        },
        {
            value: 'Marina',
            label: 'Marina'
        },
        {
            value: 'MountainViews',
            label: 'Mountain Views'
        },
        {
            value: 'OceanView',
            label: 'Ocean View'
        },
        {
            value: 'OutdoorFireplace',
            label: 'Outdoor Fireplace'
        },
        {
            value: 'OutdoorPatioWithFirepit',
            label: 'Outdoor Patio With Firepit'
        },
        {
            value: 'OutdoorPool',
            label: 'Outdoor Pool'
        },
        {
            value: 'OutdoorRecreation',
            label: 'Outdoor Recreation'
        },
        {
            value: 'Park',
            label: 'Park'
        },
        {
            value: 'Pavillion/Ramada',
            label: 'Pavillion/Ramada'
        },
        {
            value: 'Pickleball',
            label: 'Pickleball'
        },
        {
            value: 'PicnicArea',
            label: 'Picnic Area'
        },
        {
            value: 'Playground',
            label: 'Playground'
        },
        {
            value: 'PlayLawn',
            label: 'Play Lawn'
        },
        {
            value: 'Pond',
            label: 'Pond'
        },
        {
            value: 'Pool',
            label: 'Pool'
        },
        {
            value: 'PuttingGreen',
            label: 'Putting Green'
        },
        {
            value: 'Sauna',
            label: 'Sauna'
        },
        {
            value: 'Shuffleboard',
            label: 'Shuffleboard'
        },
        {
            value: 'Soccer',
            label: 'Soccer'
        },
        {
            value: 'SplashPad',
            label: 'Splash Pad'
        },
        {
            value: 'SportsCourts',
            label: 'Sports Courts'
        },
        {
            value: 'SportsFields',
            label: 'Sports Fields'
        },
        {
            value: 'Tennis',
            label: 'Tennis'
        },
        {
            value: 'TotLot',
            label: 'TotLot'
        },
        {
            value: 'Trails',
            label: 'Trails'
        },
        {
            value: 'Views',
            label: 'Views'
        },
        {
            value: 'Volleyball',
            label: 'Volleyball'
        },
        {
            value: 'WaterfrontLots',
            label: 'Waterfront Lots'
        },
        {
            value: 'WaterfrontViews',
            label: 'Waterfront Views'
        },
        {
            value: 'Waterpark',
            label: 'Waterpark'
        },
        {
            value: 'WoodedAreas',
            label: 'Wooded Areas'
        },
        {
            value: 'YogaStudio',
            label: 'Yoga Studio'
        },
        {
            value: 'Ziplining',
            label: 'Ziplining'
        },
        /** Open Amenities */
        {
            value: 'CommunityServices',
            label: 'Community Services'
        },
        {
            value: 'Education',
            label: 'Education'
        },
        {
            value: 'HealthAndFitness',
            label: 'Health And Fitness'
        },
        {
            value: 'LocalAreaAmenities',
            label: 'Local Area Amenities'
        },
        {
            value: 'SocialActivities',
            label: 'Social Activities'
        }
    ]

    static label(value) {
        return AmenitiesType.levels.find(level => level.value === value)?.label;
    }
}